import { createElement, setStyle } from 'util/dom'
import { preloadImage } from "common/common"
import wbManager from "media/white-board-manager"
import logger from '../../../../common/logger'
class CanvasWrapper {
  constructor (painter) {
    this.painter = painter
    this.originalWidth = painter.width
    this.originalHeight = painter.height
    this.displayWidth = null
    this.displayHeight = null
    // this.scaleRatio = 1
    this.painter.canvasEle = this.wrapperEle = document.createElement('div')
    this.maskCanvas = createElement('<canvas class="hst_mask_cav"></canvas>')
    this.renderCanvas = createElement('<canvas class="hst_render_cav"></canvas>')
    this.maskCtx = this.maskCanvas.getContext('2d')
    this.painter.canvasCtx = this.renderCtx = this.renderCanvas.getContext('2d')
    this.textEle = createElement('<div class="text_main hidden"></div>')
    this.pre = createElement('<pre class="pre"></pre>')
    this.painter.text = this.text = createElement('<textarea class="hst_inputTxt"></textarea>')
    this.textEle.append(this.pre)
    this.textEle.append(this.text)
    this.wrapperEle.append(this.maskCanvas)
    this.wrapperEle.append(this.renderCanvas)
    this.firstRender = false
  }
  mount (parentEle) {
    this.parentEle = parentEle
    console.log(this.wrapperEle)
    parentEle.appendChild(this.wrapperEle)
    parentEle.appendChild(this.textEle)
  }
  getRenderCanvas () {
    return {
      ele: this.renderCanvas,
      ctx: this.renderCtx
    }
  }
  setSize (width, height) {
    this.originalWidth = width
    this.originalHeight = height
  }
  /**
   * 等比完整显示
   */
  showWhiteBoardDbwz(status) {
    // 重新获取父节点宽高
    let parentWidth = this.parentEle.offsetWidth;
    let parentHeight = this.parentEle.offsetHeight;

    // 计算宽高比
    let showRatio = parentHeight / parentWidth.toFixed(6);
    let dataRatio =  this.originalHeight / this.originalWidth.toFixed(6);

    let displayWidth = null
    let displayHeight = null
    // 显示窗口比数据窗口显得更加修长，则基于宽度进行缩放
    if (showRatio > dataRatio ) {

      displayWidth = parentWidth
      displayHeight = this.originalHeight * parentWidth / this.originalWidth.toFixed(6)

      setStyle(this.wrapperEle, {
        width: `${displayWidth}px`,
        height: `${displayHeight}px`,
        position: 'absolute',
        left: 0,
        top: (parentHeight - displayHeight) / 2 + 'px',
      })
    } else { // 显示窗口比数据窗口显得更加扁平，则基于高度进行缩放
      // 设置Canvas宽高
      displayWidth = this.originalWidth * parentHeight / this.originalHeight.toFixed(6)
      displayHeight = parentHeight
      // 设置Canvas位置
      setStyle(this.wrapperEle, {
        width: `${displayWidth}px`,
        height: `${displayHeight}px`,
        position: 'absolute',
        left: (parentWidth - displayWidth) / 2 + 'px',
        top: 0,
      })
    }
    // 设置垂直滚动条
    setStyle(this.parentEle, {overflow: 'hidden'})

    this.setCanvasSize(displayWidth, displayHeight)

    // 保存设置的Canvas宽高
    this.painter.canvasWidth = displayWidth;
    this.painter.canvasHeight = displayHeight;

    // 更新缩放比例，供显示的时候使用
    this.painter.scaleRatio = displayHeight / this.originalHeight.toFixed(6);
  }

  setCanvasSize (width, height) {
    this.renderCanvas.width = width
    this.renderCanvas.height = height
    this.maskCanvas.width = width
    this.maskCanvas.height = height
  }
  /**
   * 等比适应显示
   */
  showWhiteBoardDbsy(status) {
    // 重新获取父节点宽高
    let parentWidth = this.parentEle.offsetWidth;
    let parentHeight = this.parentEle.offsetHeight;

    // 计算宽高比
    let showRatio = parentHeight / parentWidth.toFixed(6);
    let dataRatio =  this.originalHeight / this.originalWidth.toFixed(6);
    
    let displayWidth = null
    let displayHeight = null

    // 显示窗口比数据窗口显得更加修长，则基于高度进行缩放
    if (showRatio > dataRatio ) {
      displayWidth = this.originalWidth * parentHeight / this.originalHeight.toFixed(6)
      displayHeight = parentHeight
      setStyle(this.wrapperEle, {
        width: `${displayWidth}px`,
        height: `${displayHeight}px`,
        position: 'absolute',
        left: 0,
        top: 0  
      })
      setStyle(this.parentEle, {overflowX: 'scroll'})
    } else { // 显示窗口比数据窗口显得更加扁平，则基于宽度进行缩放
      // 设置Canvas宽高
      displayWidth = parentWidth;
      displayHeight = this.originalHeight * parentWidth / this.originalWidth.toFixed(6);
      setStyle(this.wrapperEle, {
        width: `${displayWidth}px`,
        height: `${displayHeight}px`,
        position: 'absolute',
        left: 0,
        top: 0,
      })
      setStyle(this.parentEle, {overflowY: 'scroll'})
    }

    this.setCanvasSize(displayWidth, displayHeight)

    // 保存设置的Canvas宽高
    this.painter.canvasWidth = displayWidth;
    this.painter.canvasHeight = displayHeight;

    // 更新缩放比例，供显示的时候使用
    this.painter.scaleRatio = this.painter.canvasHeight / this.originalHeight.toFixed(6);
  }

  /**
   * 
   */
  setOrigin () {
    this.renderCtx.restore()
    this.maskCtx.restore()
    switch (this.painter.rotateAngle) {
      case 0: 
        this.renderCtx.translate(0, 0)
        this.renderCtx.save()
        break
      case 180: 
        this.renderCtx.translate(this.painter.canvasWidth, this.painter.canvasHeight)
        this.renderCtx.scale(-1, -1)
        this.renderCtx.save()
        break
      case 90:  // 这个时候宽高值已经设置转换
        this.renderCtx.translate(this.painter.canvasWidth, 0)
        this.renderCtx.rotate(90 * Math.PI / 180);  // x轴相反 y轴向下
        this.renderCtx.save()
        break
      case 270: 
        this.renderCtx.translate(0, this.painter.canvasHeight)
        this.renderCtx.rotate(270 * Math.PI / 180);  // y轴相反 x轴向右
        this.renderCtx.save()
    }
  }
  /**
   * 等比缩放显示
   */
  showWhiteBoardDbsf(status) {
    // 设置Canvas宽高
    
    let displayWidth = this.originalWidth * this.painter.displayParam.toFixed(6) / 100;
    let displayHeight = this.originalHeight * this.painter.displayParam.toFixed(6) / 100;

    // 设置Canvas位置
    this.wrapperEle.style.position = 'absolute';

    if (displayWidth >= this.parentEle.offsetWidth) {
      this.wrapperEle.style.left = 0;
      this.parentEle.style.overflowX = 'scroll';
    } else {
      this.wrapperEle.style.left = (this.parentEle.offsetWidth - displayWidth) / 2 + "px";
      this.parentEle.style.overflowX = 'hidden';
    }
    
    if (displayHeight >= this.parentEle.offsetHeight) {
      this.wrapperEle.style.top = 0;
      this.parentEle.style.overflowY = 'scroll';
    } else {
      this.wrapperEle.style.top = (this.parentEle.offsetHeight - displayHeight) / 2 + "px";
      this.parentEle.style.overflowY = 'hidden';
    }
    setStyle(this.wrapperEle, {
      width: displayWidth + 'px',
      height: displayHeight + 'px'
    })
    this.setCanvasSize(displayWidth, displayHeight)

     // 保存设置的Canvas宽高
    this.painter.canvasWidth = displayWidth;
    this.painter.canvasHeight = displayHeight;

    // 更新缩放比例
    this.painter.scaleRatio = this.painter.displayParam.toFixed(6) / 100;
  }
  setBackgroundColor (value) {
    setStyle(this.maskCanvas, {backgroundColor: value})
  }
  setBackgroundImage (n = 0) {
    if (n > 10) return
    const convertPath = this.painter.pageStore.getConvertFilePath()
    const curPage = this.painter.pageStore.getCurPage()
    const fullPath = `${convertPath}/${curPage}.jpg`
    if (wbManager.cacheFileUrlMap.get(convertPath) && wbManager.cacheFileUrlMap.get(convertPath).get(fullPath)) {
      let imgUrl = wbManager.cacheFileUrlMap.get(convertPath).get(fullPath)
      preloadImage(imgUrl, (img) => {
        if (this.maskCanvas) {
          // this.drawImage(img)
          if (this.painter.rotateAngle === 0 || this.painter.rotateAngle === 180) {
            this.maskCtx.drawImage(img, 0, 0, this.maskCanvas.width, this.maskCanvas.height)
          } else {
            this.maskCtx.drawImage(img, 0, 0, this.maskCanvas.height, this.maskCanvas.width)
          }
        } else {
          logger.warn("Invalid canvas element!");
        }
      })
    } else {
      wbManager._getFileUrl(fullPath)
      setTimeout((() => {
        this.setBackgroundImage(++n)
      }).bind(this), 500)
    }
  }
  destoryed () {
    this.wrapperEle.remove()
  }
}
export default CanvasWrapper